<template>
	<div>
		<template-listagem-vazia :textos="textos" :total-itens="totalItens"> </template-listagem-vazia>
		<v-data-table
			:items="items"
			:headers="colunas"
			hide-default-header
			hide-default-footer
			:items-per-page="paginacaoInterna.rowsPerPage"
			:page="paginacaoInterna.page"
		>
			<template #body="{ items }">
				<v-expansion-panels class="py-2" multiple flat v-model="abertos">
					<v-expansion-panel v-for="item in items" :key="item.id" class="my-2" active-class="aberto" flat>
						<v-expansion-panel-header class="collapse-selecionados-header" ripple>
							<span class="flex-grow-0 numero-pedido"
								><strong>Pedidos do processo:</strong>
								{{ item.numeroProcesso | numeroPedidoFilter }}</span
							>
							<span class="ml-15 flex-grow-1"><strong>Órgão:</strong> {{ item.siglaOrgao }}</span>
							<!-- <span class="flex-grow-0">({{ item.quantidade }})</span> TODO essa coluna será implementada quando a requisição buscar corretamente as quantidades -->
						</v-expansion-panel-header>
						<v-expansion-panel-content class="collapse-selecionados-conteudo">
							<listagem-pedidos-por-num-processo
								:abertos="abertos"
								:total-itens-processos="items.length"
								:filtro="getFiltroPorItem(item)"
								@recarregar-processos="$emit('recarregar-processos')"
								@reset-page-processos="resetarPaginaListagem"
							></listagem-pedidos-por-num-processo>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
			</template>
			<template #no-data></template>
		</v-data-table>
		<paginacao-tabela
			v-if="hasItens"
			:total-paginas="totalPaginas"
			:total-itens="totalItens"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			@paginar="$emit('paginar')"
			:show-rows-per-page="false"
			@resetar-page="resetarPaginaListagem"
		></paginacao-tabela>
	</div>
</template>
<script>
import { TabelaColunaUtils } from '@/core/utils'
import tabela from '@/views/mixins/tabela'
import TemplateListagemVazia from '@/views/components/TemplateListagemVazia.vue'
// eslint-disable-next-line vue/max-len
import ListagemPedidosPorNumProcesso from '@/views/pages/ata/acessar/gestao-de-pedido/listagem-collapses-pedidos/listagem-pedidos-por-num-processo/ListagemPedidosPorNumProcesso.vue'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	name: 'listagem-collapses-pedidos',
	components: { ListagemPedidosPorNumProcesso, TemplateListagemVazia },
	mixins: [tabela],
	props: {
		items: {
			type: Array,
			required: true,
		},
		aba: {
			type: Object,
			required: true,
		},
		existePedido: {
			type: Boolean,
			required: true,
		},
	},
	emits: ['botao-evento', 'paginar', 'recarregar-processos'],
	data() {
		return {
			abertos: [],
			colunas: [
				new TabelaColunaUtils('', 'numeroProcesso', '50%'),
				new TabelaColunaUtils('', 'orgao', '45%'),
				new TabelaColunaUtils('', 'quantidade', '5%'),
			],
			paginacaoInterna: this.paginacao,
		}
	},
	computed: {
		textos() {
			if (!this.existePedido) {
				return { mensagem: 'Você não possui <strong>pedido adicionado</strong>' }
			} else {
				return this.aba.textoListagemVazia
			}
		},
	},
	methods: {
		resetarPaginaListagem() {
			this.paginacaoInterna.page = 1
		},
		getFiltroPorItem(item) {
			const filtro = {
				filtro: {
					numeroProcesso: item.numeroProcesso,
					idAta: this.$route.params.id,
					idOrgao: item.idOrgao,
					situacoes: this.aba.situacoes,
				},
				paginacao: paginacaoListagem(['id']),
			}

			return filtro
		},
	},
}
</script>
<style scoped lang="stylus">
.numero-pedido
	min-width: 300px

estilo-padrao()
	border .1rem solid var(--v-grey-lighten1)
	border-radius .3rem

.v-expansion-panel--active.aberto > .v-expansion-panel-header
	min-height auto

.aberto .collapse-selecionados-header
	border-bottom-left-radius 0
	border-bottom-right-radius 0

.aberto .collapse-selecionados-conteudo
	border-top-color transparent
	border-top-left-radius 0
	border-top-right-radius 0

.collapse-selecionados-header
	background-color var(--v-grey-lighten4)
	color var(--v-grey-darken1)
	estilo-padrao()

.collapse-selecionados-conteudo
	estilo-padrao()
	padding-top: .5%;
</style>
